var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnclaimedBalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    rx: 6,
    fill: "#D4F5DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.25 13.5H29.75C36 13.5 38.5 16 38.5 22.25V29.75C38.5 36 36 38.5 29.75 38.5H22.25C16 38.5 13.5 36 13.5 29.75V22.25C13.5 16 16 13.5 22.25 13.5Z",
    stroke: "#28A745",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.7129 30.0875L29.8879 21.9125",
    stroke: "#28A745",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.225 23.9625C23.0742 23.9625 23.7625 23.2742 23.7625 22.425C23.7625 21.5759 23.0742 20.8875 22.225 20.8875C21.3759 20.8875 20.6875 21.5759 20.6875 22.425C20.6875 23.2742 21.3759 23.9625 22.225 23.9625Z",
    stroke: "#28A745",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3998 31.1125C31.2489 31.1125 31.9373 30.4241 31.9373 29.575C31.9373 28.7258 31.2489 28.0375 30.3998 28.0375C29.5506 28.0375 28.8623 28.7258 28.8623 29.575C28.8623 30.4241 29.5506 31.1125 30.3998 31.1125Z",
    stroke: "#28A745",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnclaimedBalance);
export default __webpack_public_path__ + "static/media/unclaimed-balance.4db44eb21a86d7ea38525bd4de378321.svg";
export { ForwardRef as ReactComponent };